import { Step, StepLabel, Box, StepContent, Typography, Tooltip } from '@mui/material';
import _ from 'lodash';
import Theme from '../../Themes/main.theme';
import StepIcon from './StepIcon';
import { IStep } from './types';
import InfoIcon from '@mui/icons-material/Info';

function VerticalStep(props: IStep) {
  const { label, icon, key, children, active, tooltip } = props;  
  return (
    <>
      <Step key={key} expanded={true}>
        <StepLabel
          StepIconComponent={StepIcon}
          StepIconProps={{ icon, active}}
        >
          <Box sx={{ 
            backgroundColor: Theme.labelColor?.background,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 1,
            py: 1,
            pl: 1,
            ml: 1 
          }}>
            {_.isString(label)
              ? <Typography variant='h4' color={Theme.labelColor?.main}>
                {label}
              </Typography>
              : label
            }
            {tooltip && <Tooltip
              PopperProps={{
                disablePortal: true
              }} title={props?.tooltip}
              placement='right-start'>
              <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
            </Tooltip>
            }
          </Box>
        </StepLabel>
        <StepContent sx={{ marginLeft: '22px' }}>
          <Box ml={3}>
            {children}
          </Box>
        </StepContent>
      </Step>
    </>
  );
}

export default VerticalStep;